var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"success","size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.doExamine}},[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "+_vm._s(_vm.disabled? '已审核' : '审核通过'))])
}
var staticRenderFns = []

export { render, staticRenderFns }